import { useTranslation } from 'react-i18next';

const PATHS = [
  { icon: 'ri-home-4-line' },
  { icon: 'ri-hotel-line' },
  { icon: 'ri-user-star-line' },
  { icon: 'ri-stairs-line' },
];

function renderParagraphs(text: string, className: string) {
  return text.split(/\n{2,}/).filter((part) => part.length > 0).map((para, i) => (
    <p key={i} className={className}>
      {para}
    </p>
  ));
}

export default function CareerPaths() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-100/50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-12">
          <div className="relative w-full aspect-[16/9] overflow-hidden order-2 lg:order-1">
            <img
              src="/images/generated/seminar-hero-v2-2026.jpg"
              alt={t('butlerTrainingSchool.career.imgAlt')}
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>

          <div className="order-1 lg:order-2">
            {renderParagraphs(
              t('butlerTrainingSchool.career.label'),
              'text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label',
            )}
            <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
              {t('butlerTrainingSchool.career.title')}
            </h2>
            {renderParagraphs(
              t('butlerTrainingSchool.career.titleEn'),
              'section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4',
            )}
            <div className="gold-line mb-6"></div>
            {renderParagraphs(
              t('butlerTrainingSchool.career.lead'),
              'text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed',
            )}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {PATHS.map((path, idx) => (
            <div
              key={idx}
              className="card-glow bg-background-50 border border-background-200/60 p-6 flex items-start gap-5 cursor-default"
            >
              <div className="w-11 h-11 rounded-full bg-accent-500/8 border border-accent-500/20 flex items-center justify-center flex-shrink-0">
                <i className={`${path.icon} text-accent-500 text-lg`}></i>
              </div>
              <div>
                <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.06em] mb-2">
                  {t(`butlerTrainingSchool.career.${idx}.title`)}
                </h3>
                {renderParagraphs(
                  t(`butlerTrainingSchool.career.${idx}.desc`),
                  'text-[16px] text-foreground-500 tracking-[0.04em] leading-relaxed',
                )}
              </div>
            </div>
          ))}
        </div>

        {renderParagraphs(
          t('butlerTrainingSchool.career.note'),
          'text-[14px] text-foreground-400 tracking-[0.03em] leading-relaxed max-w-[900px] mx-auto mt-10 text-center',
        )}
      </div>
    </section>
  );
}
